
itemDirective = (moment) ->
    "ngInject"

    restrict: 'A'
    templateUrl: 'programs/initiatives/amcGrantReportItem'
    require: '^amcGrantReportSection'
    scope:
        config: '=amcGrantReportItem'
        grantReport: '='
        data: '='
    link: (scope, element, attrs, sectionController) ->

        scope.today = moment()
        currentQuarterStart = moment().startOf('quarter')

        if scope.config.type == 'metric'
            scope.data = scope.data or {}
            scope.data.last_verified = scope.data.last_verified or moment()
            scope.data.actual = scope.data.actual or 0

        scope.metricActualIssue = (field) ->

            return (
                not scope.grantReport.locked and
                not scope.grantReport.all_slots_complete and
                scope.data.last_verified and
                scope.data.last_verified.isBefore(currentQuarterStart, 'day') and
                not field.hasChanged and
                not sectionController.noChangeVerified)

        scope.metricChange = (dybForm) ->
            field = dybForm.actual
            return field.formData - field.viewData


module.directive 'amcGrantReportItem', itemDirective